import { AfterViewInit, Component, OnInit } from '@angular/core';
import { LayoutService } from '../../core';
import KTLayoutFooter from '../../../../../../assets/js/layout/base/footer';
import { AppPageService } from 'src/app/features/modules/page/services';
import { StaticPageModel, StaticPagePositionEnum } from 'src/app/features/modules/page/models';
import { map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { isReleaseNotesEnabled } from 'src/app/features/modules/release-notes/services/release-notes-enabled.guard';

@Component({
  selector: 'app-footer-large',
  templateUrl: './footer-large.component.html',
  styleUrls: ['./footer-large.component.scss'],
})
export class FooterLargeComponent implements OnInit, AfterViewInit {
  footerContainerCSSClasses: string;
  currentYear: string;
  currentVersion = (environment as unknown as { version: string }).version;
  releaseNotesEnabled = isReleaseNotesEnabled();
  footerPages: StaticPageModel[] = [];

  constructor(private layout: LayoutService, private appPageService: AppPageService) {
    const currentDate = new Date();
    this.currentYear = currentDate.getFullYear().toString();
  }

  ngOnInit(): void {
    this.footerContainerCSSClasses = this.layout.getStringCSSClasses('footer_container');
    this._fetchFooterLinks();
    this._listenToPagesChanges();
  }

  ngAfterViewInit() {
    // Init Footer
    KTLayoutFooter.init('kt_footer');
  }

  private _fetchFooterLinks(): void {
    this.appPageService.getAllPages().subscribe();
  }

  private _listenToPagesChanges(): void {
    this.appPageService.customPages$
      .pipe(
        map((pages: StaticPageModel[]) =>
          pages.filter(x => x.positionType === StaticPagePositionEnum.Footer)
        )
      )
      .subscribe(pages => {
        if (pages && this.footerPages.length === 0) {
          this.footerPages = pages;
        }
      });
  }
}
